import React from "react";
import { Link } from "react-router-dom";
// import { COLORS, FONT_SIZE } from "../Theme/theme";
// Corrected to v4 imports
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@material-ui/core";
import useStyles from "../../styles";

// Corrected icon imports
import LinkIcon from "@material-ui/icons/Link";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

function DaynamicReportCard({ data }) {
  const classes = useStyles();

  if (!data || !data.linkdata) return null;

  return (
    <Card
      //   sx={{ backgroundColor: COLORS.bgCard }}
      style={{
        height: "100%",
        width: "95%",
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      <CardHeader
        className={`${classes.bgblue}`}
        title={data.title}
        style={{
          color: "white",
          paddingTop: 12,
          paddingBottom: 12,
          fontSize: "12px",
        }}
        titleTypographyProps={{
          variant: "h6",
          // style: { fontSize: FONT_SIZE.sectionTitle, fontWeight: "bold" },
        }}
      />
      <Divider />
      <CardContent style={{ padding: 0 }}>
        <List disablePadding>
          {data.linkdata.map((item) => {
            const IconNode = item.icon || LinkIcon;
            return (
              <ListItem
                key={item.id}
                button
                component={Link}
                to={item.path}
                disabled={!item.validity || !item.page_status}
                style={{
                  textDecoration: "none",
                  //   color: COLORS.textPrimary,
                }}
              >
                <ListItemIcon
                  className={`${classes.bgblue}`}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    minWidth: 28,
                    // backgroundColor: COLORS.primary,
                    // color: COLORS.textPrimary,
                    // fontSize: FONT_SIZE.body,
                    marginRight: "7px",
                    padding: "2px",
                    borderRadius: "2px",
                  }}
                >
                  <IconNode style={{ color: "white", fontSize: "20px" }} />
                </ListItemIcon>

                <ListItemText
                  primary={item.name}
                  secondary={!item.validity ? "Temporarily Unavailable" : ""}
                  primaryTypographyProps={{
                    variant: "body1",
                    style: {
                      //   fontSize: FONT_SIZE.body,
                      //   color: COLORS.textPrimary,
                    },
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
}

export default DaynamicReportCard;
